export const LOGO_URL =
  "https://customer-assets-v7afamib.emergentagent.net/job_87675b96-1b30-4a9a-a302-6675bb81281e/artifacts/lwahvms4_PeopleLab%20Final%20Logo%20%28white%20bg%29.webp";

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Approach", href: "#approach" },
  { label: "Careers", href: "#careers" },
  { label: "Contact", href: "#contact" },
];

export const SERVICES = [
  {
    id: "recruitment",
    no: "01",
    title: "Recruitment & Talent Acquisition",
    desc: "We find people who don't just fill a seat, but move the whole team forward — sourced, vetted and matched to your culture.",
    tags: ["Executive search", "Volume hiring", "Employer branding"],
    image:
      "https://images.unsplash.com/photo-1690378820474-b468b8ee64d3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "consulting",
    no: "02",
    title: "HR Consulting & Compliance",
    desc: "Policies, structures and compliance frameworks that keep you protected and your people supported as you scale.",
    tags: ["Policy design", "Audits", "Labour compliance"],
    image:
      "https://images.unsplash.com/photo-1538688423619-a81d3f23454b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "payroll",
    no: "03",
    title: "Payroll & Benefits",
    desc: "Accurate, on-time payroll and benefits administration — so nobody has to think about it except us.",
    tags: ["Payroll ops", "Benefits", "Tax & filings"],
    image:
      "https://images.unsplash.com/photo-1572021335469-31706a17aaef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
  {
    id: "training",
    no: "04",
    title: "Training & Development",
    desc: "Leadership and capability programmes that turn managers into leaders and teams into high performers.",
    tags: ["Leadership", "Onboarding", "L&D strategy"],
    image:
      "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  },
];

export const CHAPTERS = [
  {
    no: "01",
    title: "People first, always",
    body: "Every framework we build starts with the humans it serves. We design HR that people actually want to use — not policy that gathers dust.",
  },
  {
    no: "02",
    title: "Process that scales",
    body: "From your tenth hire to your thousandth, we build systems that grow with you — repeatable, measurable, and refreshingly simple.",
  },
  {
    no: "03",
    title: "Possibilities unlocked",
    body: "When people and process align, momentum follows. We hand you a team that's ready for whatever comes next.",
  },
];

export const JOBS = [
  { role: "Senior HR Consultant", location: "Bengaluru · Hybrid", type: "Full-time" },
  { role: "Talent Acquisition Partner", location: "Remote · India", type: "Full-time" },
  { role: "Payroll Operations Lead", location: "Mumbai · On-site", type: "Full-time" },
  { role: "L&D Programme Manager", location: "Remote", type: "Contract" },
];

export const SERVICE_OPTIONS = [
  "Recruitment & Talent Acquisition",
  "HR Consulting & Compliance",
  "Payroll & Benefits",
  "Training & Development",
  "Something else",
];
